import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { saveAs } from 'file-saver';
import { ReportsService } from '../../../../services/reports.service';
import { RouterModule } from '@angular/router';
import { CommonService } from '../../../../services/common.service';
@Component({
    selector: 'app-permanent-repair-within-90-days',
    imports: [TableModule, CommonModule, RouterModule, FormsModule,],
    templateUrl: './permanent-repair-within-90-days.component.html',
    styleUrl: './permanent-repair-within-90-days.component.scss'
})
export class PermanentRepairWithin90DaysComponent {
  constructor(private report: ReportsService,
    public commonService: CommonService
  ) { 
    this.userCAI = this.commonService.getUserCai();

  }
  permanentRepairDateData: any;
  blueTagNumber: string = '';
  showTable: boolean = false;
  facilityID: string = ''
  userCAI = '';

  ngOnInit() {
    this.facilityID = localStorage.getItem('current_facility_id') || 'ES';
    this.getRecommendedNinetyDaysReport();
  }


  getRecommendedNinetyDaysReport() {
    this.report.getRecommendedNinetyDaysReport(this.facilityID, this.userCAI)
      .subscribe({
        next: (data) => {
          this.permanentRepairDateData = data;

        },
        error: (error) => {
          console.error('Error fetching report:', error);

        }
      });
  }

  exportToExcel() {
    const facilityId = localStorage.getItem('current_facility_id');

    if (!facilityId) {
      console.error('Facility ID is missing.');
      return;
    }

    let params = {
      facilityId: facilityId,
      userCAI: this.commonService.getUserCai(),
    }
    this.report.getRecommendedNinetyDaysReportExcel(params)
      .subscribe({
        next: (fileData: any) => {
          if (fileData) {
            saveAs(fileData, 'permanent-repair-within-90-days.xlsx');
          }

        },
        error: (err: any) => {
          console.error('Error fetching report details:', err);
        }
      })
  }
}